import type { QueryClient } from "@tanstack/react-query";
import { type LoaderFunctionArgs, defer } from "react-router-dom";
import { getOrganizationOptions } from "../../../services";

export const buildMemberLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    if (!params.organizationId) throw new Error("Organization ID is required");

    return defer({
      organization: queryClient.ensureQueryData(getOrganizationOptions(params.organizationId)),
    });
  };
